<template>
  <div class="page-development-search">
    <h1 class="sr-only">
      Search Developments
    </h1>

    <DevelopmentSearchResults />
  </div>
</template>

<script setup lang="ts">
import {useDevelopmentStore} from '~/store/development';

// DATA Definitions
//----------------------------------------------------------------------------------------------------------------------
const developmentStore = useDevelopmentStore();
const route = useRoute();
const {$development} = useNuxtApp();
const hasMounted = ref(false);

/**
 * @_SERVER_PREFETCH Hook
 */
onServerPrefetch(async () => {
  await setDevelopmentDataResponse();
});

/**
 * @_HEAD Hook
 */
useHead({
  meta: [
    {
      name: 'canonical',
      content: 'https://www.newhomes.co.nz' + route.fullPath,
    },
  ],
});

const title = 'Find Developments | New Homes - Search Top Developments in New Zealand';
const description = 'Discover top developments in New Zealand.Enter a development\'s name or location to view their stages, listings, and more on New Homes.';
useSeoMeta({
  title,
  description,
  ogTitle: title,
  ogDescription: description,
  ogImage: 'https://store.newhomeshub.co.nz/static-assets/new-homes-og-image-v2.jpg',
  twitterCard: 'summary_large_image',
  twitterTitle: title,
  twitterDescription: description,
  twitterImage: 'https://store.newhomeshub.co.nz/static-assets/new-homes-og-image-v2.jpg',
});

/**
 * @_MOUNTED Hook
 */
onMounted(async () => {
  nextTick(() => {
    hasMounted.value = true;
  });

  developmentStore.setIsLoading(true);
  if (developmentStore.developmentData.found === 0) {
    setDevelopmentDataResponse();
  } else {
    developmentStore.setIsLoading(false);
  }
});

/**
 * @_WATCH route.query
 */
watch(() => route.query, async () => {
  await setDevelopmentDataResponse();
});

/**
 * Set the development data
 */
async function setDevelopmentDataResponse () {
  developmentStore.setIsLoading(true);
  const developmentResultResponse = await $development.search();
  developmentStore.setDevelopmentData(developmentResultResponse);
  developmentStore.setIsLoading(false);
}
</script>

<style lang="scss">
.page-developments {
//
}
</style>
